import { WorldCoord } from "@latticexyz/phaserx/src/types";
import { setComponent } from "@latticexyz/recs";
import { PhaserLayer } from "../types";

export function highlightCoord(layer: PhaserLayer, coord: WorldCoord, color = 0xffffff) {
  const {
    components: { HoverHighlight },
    parentLayers: {
      local: { singletonEntity },
    },
  } = layer;

  setComponent(HoverHighlight, singletonEntity, { color, ...coord });
}
